<template>
  <div>
    <AuBreadcrumb
      :parent-name="$t('router.pages.user')"
      parent-path="user"
    />
    <Form class="card">
      <template #header>
        {{ $t("settings.title") }}
      </template>
      <div class="fieldset select-width">
        <AuSelect
          :value="units"
          :allow-empty="false"
          :select-label="$t('settings.units.label')"
          :options="unitsOpt"
          @input="setUnit"
        />
        <AuSelect
          v-if="isNotRwa"
          :value="language"
          :allow-empty="false"
          :select-label="$t('settings.language.label')"
          :options="languages"
          icon
          @input="setLocale"
        />
        <AuSelect
          :value="defaultTokenId"
          :allow-empty="false"
          :select-label="$t('settings.defaultToken.label')"
          :options="tokensOptions"
          @input="setDefaultToken"
        />
      </div>
    </Form>
  </div>
</template>

<script>
import _ from "lodash";
import { checkAccess, scope } from "@/help/accessData";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Setting",

  data() {
    return {
      unitsOpt: [
        {
          display: "Meter",
          value: "metric"
        },
        {
          display: "Feet",
          value: "imperial"
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      language: "language",
      units: "units",
      tokensFiat: "tokensFiat",
      tokensGold: "tokensGold",
      defaultTokenId: "defaultToken/defaultTokenId"
    }),

    isNotRwa() {
      return checkAccess(scope.notRwa);
    },

    tokensOptions() {
      if (!this.isNotRwa) {
        const token = _.find(this.tokensFiat, (token) => token.id == this.defaultTokenId);
        return token ? [{
          display: token.nameEng,
          value: token.id
        }] : [];
      }

      return _.map([...this.tokensFiat, ...this.tokensGold], (token) => ({
        display: token.nameEng,
        value: token.id
      }));
    },

    languages() {
      return _.map(process.env.VUE_APP_SUPPORTED_LOCALES.split(","), (lang) => {
        return {
          display: this.$t(`settings.language.${lang}`),
          value: lang,
          icon: `/img/profile/${lang}.png`
        };
      });
    }
  },

  methods: {
    ...mapActions({
      setLanguage: "setLanguage",
      setUnits: "setUnits",
      getBalances: "getBalances",
      patchCurrentUser: "patchCurrentUser"
    }),

    setLocale(language) {
      this.setLanguage(language);
    },

    setUnit(units) {
      this.setUnits(units);
    },

    async setDefaultToken(tokenId) {
      await this.patchCurrentUser({
        userId: this.$auth.user().id,
        body: { defaultToken: `/api/au_tokens/${tokenId}` }
      });
      await this.getBalances(tokenId);
      this.$auth.fetch();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  padding: 22px;

  &__header {
    display: flex;
    flex-direction: column;
    gap: 40px;

    border-bottom: 1px solid var(--color-70);
    padding-bottom: 15px;
  }
  .fieldset {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }

  .title {
    color: var(--text-color);
    font-size: 24px;
    line-height: 1em;
  }
  .profile {
    display: flex;
  }
  .person-info {
    color: var(--color-20);
  }
  .profile-fields {
    width: 50%;
    margin-top: 20px;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .inp {
      margin: 10px 0px;
    }
    .btn-save {
      margin-top: 30px;
      width: 100%;
    }
  }
  .person-fio {
    margin-right: 6px;
  }
  .data-in {
    border-radius: 10px;
    border: 1px solid lightgray;
    padding: 15px;
    margin-bottom: 10px;

    &::placeholder {
      color: var(--color-50);
    }
  }
}
.select-width {
  max-width: 350px;
}
</style>
